import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'opac-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  /**
   * Picture to apply as background image.
   */
  @Input() picture: string | undefined = undefined;
  /**
   * Displays avatar as placeholder
   */
  @HostBinding('class.placeholder')
  @Input() placeholder: boolean = false;
}
